import React, { useEffect } from "react";
import { Card, Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDataIssueSummary } from "../../../../store/slices/campaigns/dataIssue";
import { Eye } from "react-bootstrap-icons";

function DataIssueSummary({ campaignData }) {
    const { dataIssueSummary } = useSelector((store) => store.dataIssueSlice);
    const { summary = null, loading = false, error = null, } = dataIssueSummary;
    const { campaignId, campaignUuid } = campaignData;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const showDataIssueSection = (campaignData, type) => {
        navigate(`/campaign/email-campaing-report/${campaignUuid}/data-issues/${campaignId}/${type}`, {
            state: {
                campaignName: campaignData?.campaignName || "NA"
            }
        });
    }



    useEffect(() => {

        // calling api to fetch the summary
        dispatch(getDataIssueSummary({ campaignId, campaignUuid }))

    }, []);

    return (
        <>
            {summary && typeof summary === "object" && (
                <Card className="mb-4 shadow-sm">
                    <Card.Header>
                        <strong>Data Issue Summary</strong>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Table striped bordered hover responsive className="mb-0 text-center">
                            <thead>
                                <tr style={{ backgroundColor: "#e0e0e0" }}>
                                    {Object.keys(summary).map((type) => (
                                        <th key={type}>
                                            {type.charAt(0).toUpperCase() + type.slice(1)}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {Object.entries(summary).map(([type, count], idx) => (
                                        <td key={idx} className="text-center align-middle">
                                            <div className="d-flex justify-content-center align-items-center">
                                                <span className="me-2 fw-medium">{count}</span>
                                                {count > 0 && (
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        className="rounded-circle d-flex justify-content-center align-items-center"
                                                        style={{ width: "32px", height: "32px", padding: "0" }}
                                                        onClick={() => showDataIssueSection(campaignId, type, count)}
                                                    >
                                                        <Eye
                                                            title="View Report"
                                                            className="text-primary rotate-eye"
                                                            onMouseEnter={(e) =>
                                                            (e.currentTarget.style.transform =
                                                                "rotate(90deg) scale(1.2)")
                                                            }
                                                            onMouseLeave={(e) =>
                                                                (e.currentTarget.style.transform = "rotate(0deg)")
                                                            }
                                                        />
                                                    </Button>
                                                )}
                                            </div>
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </Table>
                    </Card.Body>

                </Card>
            )}
        </>
    );
}

export default DataIssueSummary;
